<template>
	<div>
		<el-form ref="form" :model="form" label-width="80px">
			<!-- <el-form-item label="您的姓名">
				<el-input v-model="form.name"></el-input>
			</el-form-item>
			<el-form-item label="手机号">
				<el-input v-model="form.phone"></el-input>
			</el-form-item> -->
			<el-form-item label="反馈内容">
				<el-input maxlength="800" type="textarea" v-model="form.content" rows="3" placeholder="如果您有关于商品的任何问题，欢迎反馈我们，我们将在第一时间回复。"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="onSubmit">提交</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				form: {
					name: '',
					phone: '',
					content: '',
				}
			};
		},
		created(){
			this.$api.homeGetEmpInfo().then(res=>{
				let data = res.data.data;
				if(this.$global.userType==1){
					this.form.name = data.cname;
				}else{
					this.form.name = data.name;
				}
				this.form.phone = data.phone;
			})
		},
		methods: {
			toBack() {
				this.$router.push({
					path: '/notice'
				});
			},
			onSubmit() {
				if(!this.form){
					this.$common.error('反馈信息不能为空');
					return;
				}
				this.$api.userFeedback(this.form).then((res)=>{
					this.$common.success("提交成功");
					this.form.content = "";
					this.$emit("close");
				})
			}
		}
	};
</script>
